import { Storage } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { List } from "@dzambalaorg/ui-kit";

import { StyledPaper } from "../styled";

export const Erc20Section = () => {
  return (
    <StyledPaper>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.hierarchy.coins" />
          </List.Subheader>
        }
      >
        <List.ItemButton<typeof RouterLink> component={RouterLink} to="/erc20/coins">
          <List.ItemIcon>
            <Storage />
          </List.ItemIcon>
          <List.ItemText>
            <FormattedMessage id="pages.erc20.coins.title" />
          </List.ItemText>
        </List.ItemButton>
      </List>
    </StyledPaper>
  );
};
